(function ($) {
  $(function () {
    function updateHeaderHeight() {
      var totalHeight = $('header > .wp-block-group').outerHeight();
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    }

    // Initial calculation
    updateHeaderHeight();

    // Recalculate on window resize
    $(window).on('resize', function () {
      updateHeaderHeight();
    });
    $('.is-style-menu-btn > button').on('click', function () {
      console.log('click');
      console.log('this', this);
      $(this).toggleClass('open');
      $('.open-menu-wrapper').toggleClass('open');
    });

    function addWrapClasses() {
      var $header = $('header');
      var $menuItems = $(
        'header .header-container .wp-block-navigation__container > .wp-block-navigation-item'
      );

      $header.removeClass('mobile-menu');

      if ($menuItems.length < 2) return;

      var firstTop = $menuItems.first().offset().top;
      var wrapped = false;

      $menuItems.each(function () {
        if ($(this).offset().top > firstTop) {
          wrapped = true;
          return false; // break loop
        }
      });

      if (wrapped) {
        $header.addClass('mobile-menu');
        var totalHeight = $('header > .wp-block-group').outerHeight();
        document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
      }
    }

    // Run on page load and window resize
    addWrapClasses();
    $(window).on('resize', addWrapClasses);
  });
})(jQuery);
